// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26kIn","col":"styles_col__11hI7"};